<template>
  <section class="search-results">
    <div class="results-summary">
      <div class="results-count-outer">
        <ListCountResults
            :total-filtered-items="data.Documents.length"
            :total-items="data.TotalResults"
        />

        <span class="line"> | </span>
        <button class="style-label-underscore clear-filters-desktop" @click="$emit('reset-search')">
          Nulstil søgning
        </button>
      </div>
    </div>
    <div class="banner-container" v-if="banner && showBanner">
      <div v-html="banner.BannerText"></div>
      <button class="close-button" type="button" @click="showBanner = !showBanner"><span aria-hidden="true">&times;</span></button>
    </div>
    <ul class="results-list">
      <li v-for="item in data.Documents" class="result-item" data-position-related-container>
        <a class="result-card-link" :href="choosePropertyValue(item, 'Uri', 'Url')"
           :title="item.Properties.find(prop => prop.Name === 'Uri')?.Value" :target="isRulesSearch ? '_blank' : null"
           @click="logClick(item.Id, item.LogicalOffset)"
           data-position-related-button>
          <article class="result-card">
            <span
                class="result-tag style-small"
                v-if="(item.Properties.find(prop => prop.Name === 'SubTypeTags')?.Value?.trim()) || (item.Properties.find(prop => prop.Name === 'SubTypeTags')?.ValueList || []).find(v => v && v.trim())"
            >
              {{
                item.Properties.find(prop => prop.Name === 'SubTypeTags')?.Value?.trim() || (item.Properties.find(prop => prop.Name === 'SubTypeTags')?.ValueList || []).find(v => v && v.trim())
              }}
            </span>
            <h2 class="result-title style-h3">{{ choosePropertyValue(item, 'PageTitle', 'Title') }}</h2>
            <div v-html="choosePropertyValue(item, 'Content', 'Description')"></div>
          </article>
        </a>
      </li>
    </ul>
    <div v-if="data.Documents.length !== data.TotalResults" class="load-more-results">
      <button @click="$emit('fetch-more-content')">Hent flere</button>
    </div>
  </section>
</template>

<script setup>

import {onMounted, ref, watch} from 'vue'
import { initHoverArrowAnimation } from '../../../layout-handlers.js'
import ListCountResults from "../listCountResults.vue";

const props = defineProps({
  data: {
    type: Object,
    required: true
  },
  selectedRuleTags: {
    type: Array,
    required: true
  },
  selectedIndustryTags: {
    type: Array,
    required: true
  },
  isRulesSearch: {
    type: Boolean,
    required: false,
    default: false
  },
  banner: {
    type: Object,
    required: false,
  },
  searchId: {
    type: String,
    required: false,
    default: null
  },
})

const showBanner = ref(true)

onMounted(async () => {
  initHoverArrowAnimation();
});

watch(() => props.data, async () => {
  initHoverArrowAnimation();
});

function logClick(documentId, logicalOffset) {
  if (!props.searchId || !documentId) return;
  fetch('/umbraco/api/searchlog/logclick', {
    method: 'POST',
    keepalive: true,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      searchId: props.searchId,
      documentId,
      offset: logicalOffset
    })
  });
}

function choosePropertyValue(item, primary, fallback) {
  const primaryValue = item.Properties.find(prop => prop.Name === primary)?.Value
  if (primaryValue && primaryValue.length > 0) {
    return primaryValue
  }
  return item.Properties.find(prop => prop.Name === fallback)?.Value
}

function choosePropertyValueMarkup(item, primary, fallback) {
  const primaryValue = item.Properties.find(prop => prop.Name === primary)?.ValueMarkup
  if (primaryValue && primaryValue.length > 0) {
    return primaryValue
  }
  return item.Properties.find(prop => prop.Name === fallback)?.ValueMarkup
}
</script>